/**
 * デバイス認証設定のreducer
 * TODO: use-immerを使って簡潔に書き直す
 * @param {Object} settings - デバイス認証設定
 * @param {Object} action - アクション
 * @returns
 */
const deviceAuthSettingsReducer = (settings, action) => {
  switch (action.type) {
    case 'setDeviceAuthSettings': {
      return action.settings;
    }
    case 'toggleDeviceAuth': {
      return {
        ...settings,
        isEnabled: action.isEnabled,
      };
    }
    case 'addedIpAddress': {
      return {
        ...settings,
        ipAddresses: [...settings.ipAddresses, action.ipAddress],
      };
    }
    case 'removedIpAddress': {
      return {
        ...settings,
        ipAddresses: settings.ipAddresses.filter(
          (ip, index) => index !== action.index,
        ),
      };
    }
    case 'updateSubscriptions': {
      return {
        ...settings,
        subscriptions: {
          ...settings.subscriptions,
          operatorIds: action.operatorIds,
        },
      };
    }
    case 'selectedGroup': {
      return {
        ...settings,
        subscriptions: {
          ...settings.subscriptions,
          groupId: action.groupId,
        },
      };
    }
    default:
      return settings;
  }
};

export default deviceAuthSettingsReducer;
